/**
 * A development build, or any build pointed at a development API (the local server, or a
 * dev- host such as dev-core.kalosflorida.com). The Development Environment badge shows under
 * this. The feature flag tooling gates on IS_PROD (featureFlags/evaluate.ts) instead, so it
 * stays in step with the local override.
 */
const API_URL = import.meta.env.VITE_API_URL ?? '';
export const IS_DEVELOPMENT_ENVIRONMENT =
  import.meta.env.DEV || API_URL.includes('localhost') || /^https?:\/\/dev[-.]/.test(API_URL);
